import Unlit from '@/glxp/shaders/unlit.glsl'
import Plane from '@/glxp/shaders/plane.glsl'
import UnlitLeaf from '@/glxp/shaders/unlitLeaf.glsl'
import Post from '@/glxp/shaders/post.glsl'
import PostHalo from '@/glxp/shaders/halo.glsl'
import Skin from '@/glxp/shaders/skining/simpleSkin.glsl'
import PointDebug from '@/glxp/shaders/pointDebug.glsl'
import LineDebug from '@/glxp/shaders/lineDebug.glsl'
import Water from '@/glxp/shaders/water.glsl'
import Plateform from '@/glxp/shaders/plateform.glsl'
import Particles from '@/glxp/shaders/particles.glsl'
import ShootingStar from '@/glxp/shaders/shootingStar.glsl'
import Background from '@/glxp/shaders/background.glsl'
import Butterfly from '@/glxp/shaders/butterfly.glsl'

// Commons
import Triplanar from '@/glxp/shaders/common/triplanar.glsl'
import ColorBurn from '@/glxp/shaders/common/colorBurn.glsl'
import Rotation from '@/glxp/shaders/common/rotation.glsl'
import NormalBlending from '@/glxp/shaders/common/normalBlending.glsl'
import ScreenBlending from '@/glxp/shaders/common/screenBlending.glsl'
import Blur from '@/glxp/shaders/common/blur5.glsl'

export default {
  'unlit': Unlit,
  'plane': Plane,
  'unlit-leaf': UnlitLeaf,
  'post': Post,
  'post-halo': PostHalo,
  'skin': Skin,
  'water': Water,
  'plateform': Plateform,
  'point-debug': PointDebug,
  'debug-line': LineDebug,
  'particles': Particles,
  'shootingStar': ShootingStar,
  'background': Background,
  'butterfly': Butterfly,

  'commons': {
    'triplanar': Triplanar,
    'colorBurn': ColorBurn,
    'rotation': Rotation,
    'blur': Blur,
    'normalBlending': NormalBlending,
    'screenBlending': ScreenBlending,
  }
}
